import { Controller } from 'stimulus';

/**
 * Automatically focuses the content of a Boostrap collapse
 * when it gets revealed, in case it's before the toggle
 * that revealed it.
 *
 * @target field (optional) - focus this instead of the collapse itself.
 */
export default class extends Controller {
  static targets = ['field'];

  connect() {
    this.listener = this.onShown.bind(this);
    this.element.addEventListener('shown.bs.collapse', this.listener);
  }

  disconnect() {
    this.element.removeEventListener('shown.bs.collapse', this.listener);
  }

  onShown() {
    if (this.hasFieldTarget) {
      this.fieldTarget.focus();
      this.fieldTarget.select?.();
      return;
    }

    this.element.focus();
  }
}
